import { render, staticRenderFns } from "./Quickreplylist.vue?vue&type=template&id=3d901144&scoped=true&"
import script from "./Quickreplylist.vue?vue&type=script&lang=js&"
export * from "./Quickreplylist.vue?vue&type=script&lang=js&"
import style0 from "./Quickreplylist.vue?vue&type=style&index=0&id=3d901144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d901144",
  null
  
)

export default component.exports